import * as msal from "@azure/msal-browser";

export async function GetAPIDomain() {
    var domain = localStorage.getItem("api-domain");

    if (!domain) {
        const response = await fetch('app-settings/domains');
        const data = await response.json();

        domain = data.domainApi;
        localStorage.setItem("api-domain", domain);
    }

    return domain;
}

export async function GetAPIHeaders() {

    var expiry = new Date(Date.parse(localStorage.getItem("expires")));

    if (expiry < new Date()) {
        console.log("Expired");
        await MyDayAdminAPI.RefreshToken();
    }

    var accessToken = localStorage.getItem("access-token");
    var headers = new Headers({ 'content-type': 'application/json', 'Authorization': 'Bearer ' + accessToken });

    return headers
}

export class MyDayAdminAPI { 

    //******************************
    // AUTHENTICATION
    //******************************

    static refresh_lock = false;

    //SIGN OUT
    static LogOut() {
        localStorage.removeItem("access-token");
        localStorage.clear();
    }

    //SET ACCESS TOKEN
    static async SetAccessToken(token: string, expiry: Date) {
        console.log("Setting: " + Date);
        console.log("Date: " + token);
        localStorage.setItem("access-token", token);
        localStorage.setItem("expiry", expiry.toISOString());
    }
    static async ClearAccessToken() {
        localStorage.removeItem("access-token");
        localStorage.removeItem("expiry");
    }

    //REFRESH TOKEN
    static async RefreshToken() {

        const msalConfig = {
            auth: {
                clientId: 'cb6c8540-e5e5-483c-8dc7-79cbf0839edf',
                authority: 'https://login.microsoftonline.com/bbd70312-bbe8-4129-b22c-51d1b5b6eb97'
            }
        };

        const msalInstance = new msal.PublicClientApplication(msalConfig);

        const silentRequest = {
            scopes: ["api://cb6c8540-e5e5-483c-8dc7-79cbf0839edf/access_as_user offline_access"]
        };

        try {
            const loginResponse = await msalInstance.ssoSilent(silentRequest);

            console.log(loginResponse);
            MyDayAdminAPI.SetAccessToken(loginResponse.accessToken, loginResponse.expiresOn);

            return true;

        } catch (err) {

            console.log("silent refresh failed");
            MyDayAdminAPI.ClearAccessToken();

            return false;
        }
    }

    //IS AUTHENTICATED
    static IsAuthenticated() {

        if (localStorage == null)
            return false;

        if (localStorage.getItem("access-token") == null)
            return false;

        var token = localStorage.getItem("access-token");
        if (token != null && token.length === 0)
            return false;

        return true;
    }

}


export class ApiResponse {

    constructor() {
        this.successful = false;
        this.authenticated = false;
    }

    static async Create(response: Response) {
        var result = new ApiResponse();

        result.authenticated = true;

        if (!response.ok) {
            result.successful = false;

            if (response.status === 401) {
                await MyDayAdminAPI.RefreshToken();
                window.location.reload();
            } else {
                try {
                    var data = await response.json();
                    result.data = data;
                    result.validationErrors = data.validationErrors;
                } catch (ex) {
                    console.log("No validate errors for this request");
                }
            }
        } else {
            result.successful = true;
            try {
                result.data = await response.json();
            } catch (ex) {
                console.log(ex);
                console.log("No content for this request");
            }
        }

        return result;
    }

    successful: Boolean;
    validationErrors: any;
    authenticated: Boolean;
    data: any;
}

export class ListQueryParams {

    constructor() {
        this.skip = 0;
        this.take = 50;
        this.direction = "Ascending"
        this.params = Array<QueryParameter>();
    }

    Sort(sort: string, direction?: string) {
        this.sort = sort;

        if (direction && direction === "desc")
            return this.Descending();
        if (direction && direction !== "desc")
            return this.Ascending();

        return this;
    }

    Descending() {
        this.direction = "Descending";
        return this;
    }

    Ascending() {
        this.direction = "Ascending";
        return this;
    }

    Paginate(skip: number, take: number) {
        this.skip = skip;
        this.take = take;
        return this;
    }

    Search(value: string) {
        this.WithParam("q", value);
        return this;
    }

    WithStart(value: any) {
        this.WithParam("start", value);
        return this;
    }

    WithEnd(value: any) {
        this.WithParam("end", value);
        return this;
    }

    WithParam(param: string, value: any) {

        this.params.push({
            key: param,
            value: value
        });

        return this;
    }

    skip: number;
    take: number;
    direction: string;
    params: QueryParameter[];
    sort?: string;

    GenerateQueryString() {
        var query = "?skip=" + this.skip + "&take=" + this.take;
        if (this.sort)
            query = query + "&sort=" + this.sort + "&direction=" + this.direction;

        if (this.params) {
            this.params.map(param => {
                if (param.value && param.key) {
                    if (param.value instanceof Date) {
                        query = query + "&" + param.key + "=" + (<Date>param.value).toISOString();
                    } else {
                        query = query + "&" + param.key + "=" + param.value;
                    }
                }
            });
        }

        return query;
    }
}


export class QueryParameter {
    key?: string;
    value?: any;
}
